/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { accountMeDestroy } from '../fn/account/account-me-destroy';
import { AccountMeDestroy$Params } from '../fn/account/account-me-destroy';
import { accountMePartialUpdate } from '../fn/account/account-me-partial-update';
import { accountMePartialUpdate$FormData } from '../fn/account/account-me-partial-update-form-data';
import { AccountMePartialUpdate$FormData$Params } from '../fn/account/account-me-partial-update-form-data';
import { AccountMePartialUpdate$Params } from '../fn/account/account-me-partial-update';
import { accountMePartialUpdate$XWwwFormUrlencoded } from '../fn/account/account-me-partial-update-x-www-form-urlencoded';
import { AccountMePartialUpdate$XWwwFormUrlencoded$Params } from '../fn/account/account-me-partial-update-x-www-form-urlencoded';
import { accountMeRetrieve } from '../fn/account/account-me-retrieve';
import { AccountMeRetrieve$Params } from '../fn/account/account-me-retrieve';
import { accountMeUpdate } from '../fn/account/account-me-update';
import { accountMeUpdate$FormData } from '../fn/account/account-me-update-form-data';
import { AccountMeUpdate$FormData$Params } from '../fn/account/account-me-update-form-data';
import { AccountMeUpdate$Params } from '../fn/account/account-me-update';
import { accountMeUpdate$XWwwFormUrlencoded } from '../fn/account/account-me-update-x-www-form-urlencoded';
import { AccountMeUpdate$XWwwFormUrlencoded$Params } from '../fn/account/account-me-update-x-www-form-urlencoded';
import { accountPolicyConfList } from '../fn/account/account-policy-conf-list';
import { AccountPolicyConfList$Params } from '../fn/account/account-policy-conf-list';
import { accountSpheresList } from '../fn/account/account-spheres-list';
import { AccountSpheresList$Params } from '../fn/account/account-spheres-list';
import { accountTermsServiceList } from '../fn/account/account-terms-service-list';
import { AccountTermsServiceList$Params } from '../fn/account/account-terms-service-list';
import { BackendPaginatedPolicyConfFileListDto } from '../models/backend-paginated-policy-conf-file-list-dto';
import { BackendPaginatedTermsServiceFileListDto } from '../models/backend-paginated-terms-service-file-list-dto';
import { BackendSphereDto } from '../models/backend-sphere-dto';
import { BackendUserRetrieveUpdateDto } from '../models/backend-user-retrieve-update-dto';

@Injectable({ providedIn: 'root' })
export class BackendApiAccountService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `accountMeRetrieve()` */
  static readonly AccountMeRetrievePath = '/api/account/me/';

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountMeRetrieve$Response(
    params?: AccountMeRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserRetrieveUpdateDto>> {
    return accountMeRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountMeRetrieve(
    params?: AccountMeRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendUserRetrieveUpdateDto> {
    return this.accountMeRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserRetrieveUpdateDto>): BackendUserRetrieveUpdateDto => r.body),
    );
  }

  /** Path part for operation `accountMeUpdate()` */
  static readonly AccountMeUpdatePath = '/api/account/me/';

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMeUpdate$Response(
    params: AccountMeUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserRetrieveUpdateDto>> {
    return accountMeUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMeUpdate(params: AccountMeUpdate$Params, context?: HttpContext): Observable<BackendUserRetrieveUpdateDto> {
    return this.accountMeUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserRetrieveUpdateDto>): BackendUserRetrieveUpdateDto => r.body),
    );
  }

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMeUpdate$XWwwFormUrlencoded$Response(
    params: AccountMeUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserRetrieveUpdateDto>> {
    return accountMeUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMeUpdate$XWwwFormUrlencoded(
    params: AccountMeUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendUserRetrieveUpdateDto> {
    return this.accountMeUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserRetrieveUpdateDto>): BackendUserRetrieveUpdateDto => r.body),
    );
  }

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMeUpdate$FormData$Response(
    params: AccountMeUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserRetrieveUpdateDto>> {
    return accountMeUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMeUpdate$FormData(
    params: AccountMeUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendUserRetrieveUpdateDto> {
    return this.accountMeUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserRetrieveUpdateDto>): BackendUserRetrieveUpdateDto => r.body),
    );
  }

  /** Path part for operation `accountMeDestroy()` */
  static readonly AccountMeDestroyPath = '/api/account/me/';

  /**
   * Удаляет текущего пользователя.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMeDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountMeDestroy$Response(
    params?: AccountMeDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return accountMeDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Удаляет текущего пользователя.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMeDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountMeDestroy(params?: AccountMeDestroy$Params, context?: HttpContext): Observable<void> {
    return this.accountMeDestroy$Response(params, context).pipe(map((r: BakendHttpResponse<void>): void => r.body));
  }

  /** Path part for operation `accountMePartialUpdate()` */
  static readonly AccountMePartialUpdatePath = '/api/account/me/';

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMePartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMePartialUpdate$Response(
    params?: AccountMePartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserRetrieveUpdateDto>> {
    return accountMePartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMePartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  accountMePartialUpdate(
    params?: AccountMePartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendUserRetrieveUpdateDto> {
    return this.accountMePartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserRetrieveUpdateDto>): BackendUserRetrieveUpdateDto => r.body),
    );
  }

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMePartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMePartialUpdate$XWwwFormUrlencoded$Response(
    params?: AccountMePartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserRetrieveUpdateDto>> {
    return accountMePartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMePartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  accountMePartialUpdate$XWwwFormUrlencoded(
    params?: AccountMePartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendUserRetrieveUpdateDto> {
    return this.accountMePartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserRetrieveUpdateDto>): BackendUserRetrieveUpdateDto => r.body),
    );
  }

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountMePartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMePartialUpdate$FormData$Response(
    params?: AccountMePartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendUserRetrieveUpdateDto>> {
    return accountMePartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Представление для получения, обновления и удаления информации о текущем пользователе.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountMePartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  accountMePartialUpdate$FormData(
    params?: AccountMePartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendUserRetrieveUpdateDto> {
    return this.accountMePartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendUserRetrieveUpdateDto>): BackendUserRetrieveUpdateDto => r.body),
    );
  }

  /** Path part for operation `accountPolicyConfList()` */
  static readonly AccountPolicyConfListPath = '/api/account/policy_conf/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountPolicyConfList()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountPolicyConfList$Response(
    params?: AccountPolicyConfList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedPolicyConfFileListDto>> {
    return accountPolicyConfList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountPolicyConfList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountPolicyConfList(
    params?: AccountPolicyConfList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedPolicyConfFileListDto> {
    return this.accountPolicyConfList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendPaginatedPolicyConfFileListDto>): BackendPaginatedPolicyConfFileListDto => r.body,
      ),
    );
  }

  /** Path part for operation `accountSpheresList()` */
  static readonly AccountSpheresListPath = '/api/account/spheres/';

  /**
   * Возвращает список сфер на текущем языке интерфейса (ru/en).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountSpheresList()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountSpheresList$Response(
    params?: AccountSpheresList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendSphereDto>>> {
    return accountSpheresList(this.http, this.rootUrl, params, context);
  }

  /**
   * Возвращает список сфер на текущем языке интерфейса (ru/en).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountSpheresList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountSpheresList(params?: AccountSpheresList$Params, context?: HttpContext): Observable<Array<BackendSphereDto>> {
    return this.accountSpheresList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendSphereDto>>): Array<BackendSphereDto> => r.body),
    );
  }

  /** Path part for operation `accountTermsServiceList()` */
  static readonly AccountTermsServiceListPath = '/api/account/terms_service/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `accountTermsServiceList()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountTermsServiceList$Response(
    params?: AccountTermsServiceList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendPaginatedTermsServiceFileListDto>> {
    return accountTermsServiceList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `accountTermsServiceList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  accountTermsServiceList(
    params?: AccountTermsServiceList$Params,
    context?: HttpContext,
  ): Observable<BackendPaginatedTermsServiceFileListDto> {
    return this.accountTermsServiceList$Response(params, context).pipe(
      map(
        (r: BakendHttpResponse<BackendPaginatedTermsServiceFileListDto>): BackendPaginatedTermsServiceFileListDto =>
          r.body,
      ),
    );
  }
}
